'use strict';
let throttleTimer: boolean;

export function throttle(callback: Function, time: number) {
    if (throttleTimer) return;
    throttleTimer = true;
    setTimeout(() => {
        callback();
        throttleTimer = false;
    }, time);
}

export function getCookieValue(name: string) {
    const prefix = `${name}=`;
    for (const part of document.cookie.split(';')) {
        const cookie = part.trim();
        if (cookie.startsWith(prefix)) {
            const value = cookie.slice(prefix.length);
            if (value) {
                return value;
            }
        }
    }
}
